import{keccak256 as r}from"../crypto/keccak.js";import{toUtf8Bytes as t}from"../utils/utf8.js";function o(o){return r(t(o))}export{o as id};
